import Resource from "./resource";

export class MultiTenancyStatusResource extends Resource {
    Enabled: boolean;
}

export default MultiTenancyStatusResource;
